import jwtDecode from 'jwt-decode';

import {
    apiPath,
    appRoutes,
} from "../../constants";

import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    history,
    removeUserToken,
    resetSessionExpirationGuard,
    transformHttpResponse,
} from 'utils';

import { collectClientInfo } from 'utils/Device/clientInfo';

import {
    addErrorMessage,
    addInfoMessage, addSuccessMessage,
} from 'actions';

export const LOGIN_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGIN_FAILURE = 'LOGIN_USER_FAILURE';
export const LOGIN_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGOUT_USER = 'LOGOUT_USER';

export const loginUser = (username, password, redirect="/") => {
    return function(dispatch) {
        dispatch(loginUserRequest());
        // The device, for «Журнал входів» (utils/Device/clientInfo.js).
        return collectClientInfo()
            .then(client => axios(apiRequestOptions(apiPath.USER.AUTH_LOGIN, {username, password, client}, {withoutAuth: true})))
            .then(transformHttpResponse)
            .then(response => {
                try {
                    const {token} = response.data;
                    jwtDecode(token);
                    dispatch(loginUserSuccess(response.data));
                    history.push(redirect);
                    dispatch(addSuccessMessage('Successfully logged in'));
                } catch (e) {
                    const error = {response: {
                        status: 403,
                        data:{
                            message: 'Invalid token',
                        }
                    }};
                    dispatch(loginUserFailure(error));
                    dispatch(errorRequestHandler(error));
                }
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(loginUserFailure(error));
            });
    }
};

export const logoutUser = (notify = false) => {
    removeUserToken();
    history.push(appRoutes.AUTH_LOGIN_PAGE);
    return function(dispatch) {
        if (notify) {
            dispatch(addInfoMessage('You are logged out now'));
        }
        dispatch({
            type: LOGOUT_USER
        });
    };
};

const loginUserRequest = () => {
    return {
        type: LOGIN_REQUEST,
    }
};

const loginUserFailure = (error) => {
    localStorage.removeItem('token');
    const {data = {}} = error
    return function(dispatch) {
        dispatch(addErrorMessage(data.message));
        dispatch({
            type: LOGIN_FAILURE,
            payload: {
                status: data.code,
                message: data.message,
            }
        });
    };
};

const loginUserSuccess = data => {
    const {token} = data;
    localStorage.setItem('token', token);
    // A fresh, valid session — the NEXT time this token expires must be
    // handled again (see errorRequestHandler.js's session-expiration guard).
    resetSessionExpirationGuard();
    return {
        type: LOGIN_SUCCESS,
        payload: {
            token,
        }
    }
};